import { css, html } from 'react-strict-dom';
import { Text } from 'src/components';
import { Style } from 'src/constants';

type Props = {
  label: string;
  count: number;
  /** Says what marks this group out, where a card carries more than one. */
  hint?: string;
};

export default function ProjectsSectionHeading({ label, count, hint }: Props) {
  return (
    <html.div style={[Style.row, Style.alignCenter, styles.heading]}>
      <Text typeface="caption.semiBold" color="neutral60">
        {label}
      </Text>
      <Text typeface="caption.medium" color="neutral40">
        {count}
      </Text>
      {hint && (
        <Text typeface="caption.medium" color="neutral40">
          {`· ${hint}`}
        </Text>
      )}
    </html.div>
  );
}

const styles = css.create({
  heading: {
    gap: 6,
    paddingTop: 14,
    paddingBottom: 6,
    paddingInline: 16,
  },
});
